import React, { createContext, useCallback, useContext, useState } from 'react';

/*
  Idioma de la web pública. La web pública del menú está en español e inglés británico; las landings de embudo,
  solo en español. El selector de idioma aparece en la cabecera únicamente donde hay traducción.
  Se guarda en localStorage («fhc-lang») y se avisa con el evento «fhc-lang-change» (lo escucha el chat).
*/
const SiteLangCtx = createContext({ lang: 'es', setLang: () => {} });

function initialLang() {
  try { return localStorage.getItem('fhc-lang') === 'en' ? 'en' : 'es'; } catch { return 'es'; }
}

export function SiteLangProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);
  const setLang = useCallback((l) => {
    const next = l === 'en' ? 'en' : 'es';
    setLangState(next);
    try { localStorage.setItem('fhc-lang', next); } catch { /* almacenamiento no disponible */ }
    window.dispatchEvent(new CustomEvent('fhc-lang-change', { detail: next }));
  }, []);
  return <SiteLangCtx.Provider value={{ lang, setLang }}>{children}</SiteLangCtx.Provider>;
}

export const useSiteLang = () => useContext(SiteLangCtx);

// Rutas con versión en inglés (muestran el selector de idioma). 04/11/2026: toda la web pública del menú.
// Siguen solo en español las landings de embudo (/presentacion, /masterclass, /masterclass-en-directo):
// su vídeo, la sesión y la llamada son en español.
export const TRANSLATED_PATHS = ['/', '/como-funciona', '/membresias', '/membresias/pro', '/membresias/premium',
  '/bootcamp-tokenizacion', '/eventos', '/contacto', '/thank-you', '/terms-conditions', '/privacy-policy-fhc'];
const TRANSLATED_PREFIXES = ['/eventos/', '/diploma/'];

export const isTranslatedPath = (pathname) => {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  return TRANSLATED_PATHS.includes(p) || TRANSLATED_PREFIXES.some((x) => p.startsWith(x));
};

// Idioma efectivo de una página: el elegido si la página está traducida; si no, español
export const pageLang = (pathname, lang) => (isTranslatedPath(pathname) ? lang : 'es');

// Formato de fechas: español de España o inglés británico
export const dateLocale = (lang) => (lang === 'en' ? 'en-GB' : 'es-ES');

export function FlagES({ className = 'w-6 h-6' }) {
  return (
    <svg className={className} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <clipPath id="site-es-clip"><circle cx="16" cy="16" r="16" /></clipPath>
      <g clipPath="url(#site-es-clip)">
        <rect width="32" height="32" fill="#C60B1E" />
        <rect y="8" width="32" height="16" fill="#FFC400" />
      </g>
    </svg>
  );
}

export function FlagEN({ className = 'w-6 h-6' }) {
  return (
    <svg className={className} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <clipPath id="site-en-clip"><circle cx="16" cy="16" r="16" /></clipPath>
      <g clipPath="url(#site-en-clip)">
        <rect width="32" height="32" fill="#012169" />
        <path d="M0 0L32 32M32 0L0 32" stroke="white" strokeWidth="4" />
        <path d="M0 0L32 32M32 0L0 32" stroke="#C8102E" strokeWidth="2" />
        <path d="M16 0V32M0 16H32" stroke="white" strokeWidth="6" />
        <path d="M16 0V32M0 16H32" stroke="#C8102E" strokeWidth="3.5" />
      </g>
    </svg>
  );
}
